/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import { useDispatch } from 'react-redux';
import { useThree } from '@react-three/fiber';
import React, { useMemo, useState } from 'react';

import { const_var, params } from '../../../../../../redux/reducers/reducer';
import * as actionCreator from '../../../../../../action/index';

import useMouseEvents from '../../../../../../hooks/useMouseEvents';
import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../utils/Functions';
import { MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../CustomMaterial';
import { createSidingTextureObject } from '../../../../../../redux/reducers/utils';
import { CSG } from '../../../../../../assets/libs/csg-lib';
const OutsideWallModel = () => {
    const { gl } = useThree();
    const dispatch = useDispatch();
    
    const [wallCloseState, setWallCloseState] = useState(0);

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false



    const endStrorgeRightWallModel = useMemo(() => {
        let model = new THREE.Shape();
        model.moveTo(-(params.p_d / 2 + 0.15), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) - 0.001 : params.p_h - 0.001);
        model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) - 0.001 : params.p_h - 0.001);
        model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02,0);
        model.lineTo(-(params.p_d / 2 + 0.15), 0);
        model.closePath()

        return model;
    }, [params.p_d, params.singleSlope, params.freeStandingSide, params.p_h, params.p_r_p, params.p_w, params.p_u_t])
    
    const mainWallModel = useMemo(() => {
        let model = new THREE.Shape();

        if (wallCloseState > -1) {
            model.moveTo(-(params.p_d / 2 + 0.15), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) - 0.001 : params.p_h - 0.001);
            model.lineTo(params.p_d / 2 + 0.15, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) - 0.001 : params.p_h - 0.001);
            model.lineTo(params.p_d / 2 + 0.15, wallCloseState);

            if(params.cB_addStorage_check_front) {
                model.lineTo(params.p_d / 2 + 0.15, 0);
                model.lineTo(params.p_d / 2 - parseInt(params.cB_addStorage_front), 0);
                model.lineTo(params.p_d / 2 - parseInt(params.cB_addStorage_front), wallCloseState);                
            }
            model.lineTo(-(params.p_d / 2 + 0.15), wallCloseState);
            model.closePath()
        } else {
            if (params.cB_addStorage_check_front) {
                model.moveTo(params.p_d / 2 + 0.15, params.p_h - 0.001);
                model.lineTo(params.p_d / 2 - parseInt(params.cB_addStorage_front), params.p_h - 0.001);
                model.lineTo(params.p_d / 2 - parseInt(params.cB_addStorage_front), 0);
                model.lineTo(params.p_d / 2 + 0.15, 0);
                model.closePath()
            }
        }

        let verticalHorizontalPos = {"x": params.p_w / 2 + 0.005,"y" : ((params.p_w_c_n && (params.p_r_w === 'Close' || params.p_u_c)) ? 2.935 : 0), "z" : params.p_d / 2 + 0.15}
        let verticalHorizontalRot = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let patternLength = params.p_h - 0.01 + ((params.p_w_c_n && (params.p_r_w === 'Close' || params.p_u_c)) ? -2.935 : 0)
        let patternDepth = params.p_d + 0.3
        
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength,isPattern), extrudeSettings(patternDepth)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('right', 'wall'), extrudeSettings(1)))
        const meshEndStorageModel = new THREE.Mesh(new THREE.ExtrudeGeometry(endStrorgeRightWallModel, extrudeSettings(1)))
        const meshWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(model, extrudeSettings(1)))
    
        let meshWallModel_Temp = meshWallModel.clone();
        meshWallModel_Temp.position.set(verticalHorizontalPos.x,verticalHorizontalPos.y,verticalHorizontalPos.z);
        meshWallModel_Temp.rotation.set(verticalHorizontalRot.x,verticalHorizontalRot.y,verticalHorizontalRot.z);
        meshWallModel_Temp.updateMatrixWorld();
    
        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.p_w / 2 + 0.5, 0, 0);
        meshDelModel_Temp.rotation.set(0,Math.PI / -2,0)
        meshDelModel_Temp.updateMatrixWorld();

        const meshEndStorageModel_Temp = meshEndStorageModel.clone();
        meshEndStorageModel_Temp.rotation.set(0, -Math.PI / 2, 0);
        meshEndStorageModel_Temp.position.set(params.p_w / 2 + 0.5, 0, params.endStoragePositionZ)
        meshEndStorageModel_Temp.updateMatrixWorld()
    
        let meshWallDelModel_Temp = meshWallDelModel.clone();
        meshWallDelModel_Temp.position.set(params.p_w / 2 + 0.5, 0, 0);
        meshWallDelModel_Temp.rotation.set(0,Math.PI / -2,0)
        meshWallDelModel_Temp.updateMatrixWorld();
    
        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshWallDelModel_CSG = CSG.fromMesh(meshWallDelModel_Temp);
        const meshEndStorageModel_CSG = CSG.fromMesh(meshEndStorageModel_Temp);
    
        const wallModel_CSG = meshWallModel_CSG.subtract(meshDelModel_CSG);
        const meshWallDel_CSG = wallModel_CSG.intersect(meshWallDelModel_CSG);
        
        let endStorageModel_CSG;
        if(params.p_u_c){
            endStorageModel_CSG = meshWallDel_CSG.subtract(meshEndStorageModel_CSG);
        } else{
            endStorageModel_CSG = meshWallDel_CSG
        }

        const CSGWallModel = CSG.toMesh(endStorageModel_CSG,new THREE.Matrix4())
    
        /************** cutting hole in wainscot using CSG ***************/

        // let verticalHorizontalWaingscotPos = params.p_v_w == true ? {"x":params.p_w / 2 + 0.005,"y": 0, "z": -params.p_d / 2 - 0.15 } : {"x": params.p_w / 2 + 0.005,"y" : 0, "z" : params.p_r_w === 'Close' ? params.p_d / 2 + 0.15: -params.p_d / 2 + parseInt(params.p_u_t) }
        // let verticalHorizontalWaingscotRot = params.p_v_w == true ? {"x":Math.PI / -2,"y" : 0,"z" : Math.PI / -2} : {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let wainscotVerticalHorizontalPos = {"x": params.p_w / 2 + 0.005,"y" : 0, "z" : params.p_d / 2 + 0.15}
        let wainscotVerticalHorizontalRot = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let lengthPattern = 3
        let depthPattern = params.p_d + 0.3
    
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPattern,isPattern && params.wainscotTexture == "none"), extrudeSettings(depthPattern)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set(wainscotVerticalHorizontalPos.x,wainscotVerticalHorizontalPos.y,wainscotVerticalHorizontalPos.z);
        meshWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRot.x,wainscotVerticalHorizontalRot.y,wainscotVerticalHorizontalRot.z);
        meshWainscotModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);
    
        const wainscotModel_CSG = meshWainscotModel_CSG.subtract(meshDelModel_CSG);
        const wainscotModelCSG = wainscotModel_CSG.intersect(meshWallDelModel_CSG);

        let endStorageWailscotModel_CSG;
        if(params.p_u_c){
            endStorageWailscotModel_CSG = wainscotModelCSG.subtract(meshEndStorageModel_CSG);
        } else{
            endStorageWailscotModel_CSG = wainscotModelCSG
        }
        const CSGWainscotModel = CSG.toMesh(
            endStorageWailscotModel_CSG,
            new THREE.Matrix4()
        )

        return {
            wall: CSGWallModel.geometry,
            wainScot: CSGWainscotModel.geometry
        }
    
    }, [params.wallTexture,params.wainscotTexture,params.p_d, params.p_h, params.p_w, params.p_r_p, wallCloseState, params.p_u_c, parseInt(params.p_u_t),params.singleSlope, params.p_w_c_n, const_var.newDoorsArray, const_var.newDoorsArray.length, params.p_v_w, params.p_r_w, params.endStoragePositionZ])

    useMemo(() => {
        var wallCloseValue = -1;
        var tempCutState = -1;
        let finalHeight = (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) : params.p_h
        if(params.cB_addStorage_check_right) params.p_r_w = 'Close'

        if (params.p_r_w === 'Open' || typeof(params.p_r_w) === 'object') {
            wallCloseValue = -1;
        } else if (params.p_r_w === "One_Fourth_Close") {
            wallCloseValue = (finalHeight * 3) / 4;
        } else if (params.p_r_w === "Half_Close") {
            wallCloseValue = finalHeight / 2;
        } else if (params.p_r_w === "Three_Fourth_Close") {
            wallCloseValue = finalHeight / 4;
        } else if (params.p_r_w === "Close") {
            wallCloseValue = 0;
        } else {
            wallCloseValue = finalHeight - (3 * params.p_r_w) - 0.2;
        }

        if (params.p_c_p_r) {
            if (params.p_r_w === 'Open' || typeof(params.p_r_w) === 'object') {
                tempCutState = finalHeight - 1.5;
            } else {
                tempCutState = wallCloseValue - 1.5;
            }
        } else {
            tempCutState = wallCloseValue;
        }
        
        if (params.add_right_lean) {
            let leanFinalHeight = params.p_h - (params.leanR_p_h + (params.leanStyle.right === "gable" ? 0 : (parseInt(params.b_l_t_r_pR) / 12 * params.leanR_p_w)));

            if(params.add_right_lean && leanFinalHeight > 0 &&  (Math.abs(params.p_r_w) * 3) -leanFinalHeight < 3)
            {    
                let wH = leanFinalHeight+0.2;
                tempCutState = params.p_h - wH + (params.p_r_s === 1 && const_var.roofRegularDst * 2);
            } else {
                if(isNaN(params.p_r_w) == false){
                    let wH = (3 * params.p_r_w) - 0.2;
                    tempCutState = finalHeight - wH + (params.p_r_s === 1 && const_var.roofRegularDst * 2);
                }else if(params.p_r_w === 'Open' && params.p_c_p_r){
                    tempCutState = params.p_h
                }
            }

            if (params.p_c_p_r) {
                if (params.p_r_w === 'Open'){
                    dispatch(actionCreator.setLeftWallCloseState(tempCutState, "right"));
                    setWallCloseState(tempCutState);
                }else{
                    dispatch(actionCreator.setLeftWallCloseState(tempCutState - 1.5, "right"));
                    setWallCloseState(tempCutState - 1.5);
                }
            }else{
                dispatch(actionCreator.setLeftWallCloseState(tempCutState, "right"));
                setWallCloseState(tempCutState);
            }
        } else {
            /** cutting panel options isn't disabled when wall close state over limit */
            if (tempCutState > 0) {
                setWallCloseState(tempCutState);
                dispatch(actionCreator.setLeftWallCloseState(tempCutState, "right"));
            } else {
                if (params.p_r_w === 'Open' || typeof(params.p_r_w) === 'object') {
                    dispatch(actionCreator.setLeftWallCloseState(-1, "right"));
                    setWallCloseState(-1);
                } else {
                    setWallCloseState(0);
                    dispatch(actionCreator.setLeftWallCloseState(0, "right"));
                }
            }
        }
    
    }, [params.p_r_w, params.p_r_p, params.p_r_s, params.p_c_p_r, params.p_h, params.add_right_lean, params.leanR_p_h, params.leanR_p_w, params.b_l_t_r_pR, params.cB_addStorage_check_right, params.singleSlope, params.p_w_c_n,params.p_v_w])
    
    const handleMouseEvent = (e) => {
        if ((params.activeWall !== "c_b_l_s_r_w" && params.activeWall !== "L_L_R_S_W" && const_var.focusedSection == "center")) {
            switch (e.type) {
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);

     

    return (
        <group {...eventHandlers} >
            {(wallCloseState > -1 || (params.p_r_w === 'Close')) && mainWallModel.wall &&
                <mesh name="c_b_r_w" geometry={mainWallModel.wall} renderOrder={1}>
                    <MaterialOuterWallNew isPattern={isPattern} visibleSection={"center"} />
                </mesh>
            }
            {(params.p_w_c_n === true && ((params.p_r_w === "Close") || params.cB_addStorage_check_right)) && mainWallModel.wainScot &&
                <mesh name="c_b_r_w_wainscot" geometry={mainWallModel.wainScot} position={[0.005, 0, 0]} renderOrder={1}>
                    <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"center"} />
                </mesh>
            }
        </group>
    )
}

export default OutsideWallModel